import http from "@/utils/http";


export const NexusCommandApi = {
  //批量下发远程开门指令
  batchRemoteOpenDoor(data){
    return http.post(`/nexus/command/batchRemoteOpenDoor`,data )
  },
  //批量下发紧急门禁指令
  batchNexusEmergencyOpenDoor(data){
    return http.post(`/nexus/command/batchNexusEmergencyOpenDoor`,data )
  },
}
